import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'uikit/Icon';
import Menu, { MenuItem } from 'uikit/Menu';

import styles from './LanguageSelector.module.scss';

const cx = classNames.bind(styles);

const LanguageSelector = ({ className, handleLanguageChange, language, t }) => (
  <div className={className}>
    <Menu
      toggle={
        <button
          aria-label={t(
            'Auth/Shared/Container/LanguageSelector/aria-change-language',
          )}
          className={cx('toggle')}
          type="button"
        >
          <p className={cx('toggle-text')}>{language.toUpperCase()}</p>
          <Icon className={cx('toggle-icon')} name="chevron-down" />
        </button>
      }
    >
      <MenuItem
        isActive={language === 'en'}
        onClick={() => handleLanguageChange('en')}
      >
        English
      </MenuItem>
      <MenuItem
        isActive={language === 'fr'}
        onClick={() => handleLanguageChange('fr')}
      >
        Français
      </MenuItem>
      <MenuItem
        isActive={language === 'nl'}
        onClick={() => handleLanguageChange('nl')}
      >
        Nederlands
      </MenuItem>
    </Menu>
  </div>
);

LanguageSelector.propTypes = {
  className: PropTypes.string,
  handleLanguageChange: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

LanguageSelector.defaultProps = {
  className: undefined,
};

export default LanguageSelector;
